import React, { useState, useEffect } from "react";
import {
  Switch,
  List,
  Avatar,
  Button,
  Modal as ModalAntd,
  notification,
  message
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  StopOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import NoAvatar from "../../../../assets/img/png/no-avatar.png";
import Modal from "../../../../components/Modal";
import EditWorkersForm from "../EditWorkersForm";
import AddWorkersForm from "../AddWorkersForm";
import {
  getAvatarApi
} from "../../../../api/user";
import { getAccessTokenApi } from "../../../../api/auth";
import { deletes } from "../../../../api/delete";
import { put } from "../../../../api/put";

import "./ListWorkers.scss";

const { confirm } = ModalAntd;

export default function ListWorkers(props) {
  const { workersActive, workersInactive, setReloadWorkers } = props;
  const [viewWorkersActives, setViewWorkersActives] = useState(true);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  const addWorkersModal = () => {
    setIsVisibleModal(true);
    setModalTitle("Creating new workers...");
    setModalContent(
      <AddWorkersForm
        setIsVisibleModal={setIsVisibleModal}
        setReloadWorkers={setReloadWorkers}
      />
    );
  };

  return (
    <div className="list-users">
      <div className="list-users__header">
        <div className="list-users__header-switch">
          <Switch
            defaultChecked
            onChange={() => setViewWorkersActives(!viewWorkersActives)}
          />
          <span>
            {viewWorkersActives ? "Active workers" : "Inactive workers"}
          </span>
        </div>
        <Button type="primary" style={{
          backgroundColor:'white',
          borderWidth:'2px',
          fontSize:'15px',
          color:'rgb(35,148,212)',
          fontFamily:'report-bold',
        }} onClick={addWorkersModal}>
          Add new worker
        </Button>
      </div>
      {viewWorkersActives ? (
        <WorkersActive
          workersActive={workersActive}
          setIsVisibleModal={setIsVisibleModal}
          setModalTitle={setModalTitle}
          setModalContent={setModalContent}
          setReloadWorkers={setReloadWorkers}
        />
      ) : (
        <WorkersInactive
          workersInactive={workersInactive}
          setReloadWorkers={setReloadWorkers}
        />
      )}

      <Modal
        title={modalTitle}
        isVisible={isVisibleModal}
        setIsVisible={setIsVisibleModal}
      >
        {modalContent}
      </Modal>
    </div>
  );
}

function WorkersActive(props) {
  const {
    workersActive,
    setIsVisibleModal,
    setModalTitle,
    setModalContent,
    setReloadWorkers,
  } = props;

  const editWorker = (worker) => {
    setIsVisibleModal(true);
    setModalTitle(
      `Edit ${worker.name}`
    );
    setModalContent(
      <EditWorkersForm
        worker={worker}
        setIsVisibleModal={setIsVisibleModal}
        setReloadWorkers={setReloadWorkers}
      />
    );
  };

  return (
    <div style={{border: '5px solid rgb(203,234,247)'}}>
      <List 
        className="users-active"
        itemLayout="horizontal"
        dataSource={workersActive}
        renderItem={(worker) => (
          <WorkerActive
            worker={worker}
            editWorker={editWorker}
            setReloadWorkers={setReloadWorkers}
          />
        )}
      />
    </div>
  );
}

function WorkerActive(props) {
  const { worker, editWorker, setReloadWorkers } = props;
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    if (worker.avatar) {
    // getAvatarApi(worker.avatar).then((response) => {
      //   setAvatar(response);
      // });
      setAvatar(worker.avatar)
    } else {
      setAvatar(null);
    }
  }, [worker]);

  const desactivateWorker = () => {
    const accesToken = getAccessTokenApi();

    const dat ={
      active: false,
    }
    put(dat,'activate-worker','activate-worker',`/${worker.name}`)
    // activateVehicleApi(accesToken, vehicle.name, false)
      .then((response) => {
        // notification["success"]({
        //   message: response,
        // });
        message.success('Worker desactivated')
        setReloadWorkers(true);
      })
      .catch((err) => {
        // notification["error"]({
        //   message: err.message,
        // });
        message.error(err.message)
      });
  };

  const showDeleteConfirm = () => {
    const accesToken = getAccessTokenApi();

    confirm({
      title: "Eliminando worker",
      content: `¿Estas seguro que quieres eliminar a ${worker.name}?`,
      okText: "Eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      onOk() {
        deletes('delete-worker','delete-worker',`/${worker.name}` )
        // deleteVehicleApi(accesToken, vehicle.name)
          .then((response) => {
            // notification["success"]({
            //   message: response,
            // });
            message.success('Worker deleted')
            setReloadWorkers(true);
          })
          .catch((err) => {
            // notification["error"]({
            //   message: err.message,
            // });
            message.error(err.message)
          });
      },
    });
  };

  return (
    <List.Item className="cont" 
      actions={[
        <Button type="primary" style={{
          backgroundColor:'white',
          borderWidth:'2px',
          fontSize:'15px'
        }} onClick={() => editWorker(worker)}>
          <EditOutlined style={{color:'rgb(0,104,178)'}}/>
        </Button>,
        <Button type="danger" style={{
          backgroundColor:'white',
          borderWidth:'2px',
          fontSize:'15px'
        }} onClick={desactivateWorker}>
          <StopOutlined style={{
          color:'red'
        }}/>
        </Button>,
        <Button type="danger" style={{
          backgroundColor:'white',
          borderWidth:'2px',
          fontSize:'15px'
        }} onClick={showDeleteConfirm}>
          <DeleteOutlined style={{
          color:'red'
        }}/>
        </Button>,
      ]}
    >
      <List.Item.Meta className="conte"
        avatar={<Avatar src={avatar ? avatar : NoAvatar} style={{border: '3px solid rgb(0,104,178)'}} size={50}/>}
        title={`${worker.name ? worker.name : "..."}`}
        description={worker.types}
      />
    </List.Item>
  );
}

function WorkersInactive(props) {
  const { workersInactive, setReloadWorkers } = props;

  return (
    <List
      className="users-active"
      itemLayout="horizontal"
      dataSource={workersInactive}
      renderItem={(worker) => (
        <WorkerInactive worker={worker} setReloadWorkers={setReloadWorkers} />
      )}
    />
  );
}

function WorkerInactive(props) {
  const { worker, setReloadWorkers } = props;
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    if (worker.avatar) {
      // getAvatarApi(worker.avatar).then((response) => {
      //   setAvatar(response);
      // });
      setAvatar(worker.avatar)
    } else {
      setAvatar(null);
    }
  }, [worker]);

  const activateWorker = () => {
    const accesToken = getAccessTokenApi();

    const dat ={
      active: true,
    }
    put(dat,'activate-worker','activate-worker',`/${worker.name}`)
    // activateVehicleApi(accesToken, vehicle.name, true)
      .then((response) => {
        // notification["success"]({
        //   message: response,
        // });
        message.success('Worker activated')
        setReloadWorkers(true);
      })
      .catch((err) => {
        // notification["error"]({
        //   message: err.message,
        // });
        message.success('Worker created')
      });
  };

  const showDeleteConfirm = () => {
    const accesToken = getAccessTokenApi();

    confirm({
      title: "Eliminando worker",
      content: `¿Estas seguro que quieres eliminar a ${worker.name}?`,
      okText: "Eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      onOk() {
        deletes('delete-worker','delete-worker',`/${worker.name}` )
          .then((response) => {
            // notification["success"]({
            //   message: response,
            // });
            message.success('Worker deleted')
            setReloadWorkers(true);
          })
          .catch((err) => {
            // notification["error"]({
            //   message: err.message,
            // });
            message.error(err.message)
          });
      },
    });
  };

  return (
    <div style={{border: '5px solid rgb(203,234,247)',padding:'20px'}}>
    <List.Item
      actions={[
        <Button type="primary" style={{
          backgroundColor:'white',
          borderWidth:'2px',
          fontSize:'15px'
        }} onClick={activateWorker}>
          <CheckOutlined style={{color:'rgb(0,104,178)'}}/>
        </Button>,
        <Button type="danger" style={{
          backgroundColor:'white',
          borderWidth:'2px',
          fontSize:'15px'
        }} onClick={showDeleteConfirm}>
          <DeleteOutlined style={{
          color:'red'
        }}/>
        </Button>,
      ]}
    >
      <List.Item.Meta
        avatar={<Avatar src={avatar ? avatar : NoAvatar} style={{border: '3px solid rgb(0,104,178)'}} size={50}/>}
        title={`${worker.name ? worker.name : "..."}`}
        description={worker.types}
      />
    </List.Item>
    </div>
  );
}
